(function(){
    "use strict";
    
    angular
        .module("app")
        .service("lookupsService", service);

    function service($http) {
        const self = this;

        let orderStatusesPromise;
        self.getOrderStatuses = () => orderStatusesPromise || (orderStatusesPromise = $http.get('/api/lookups/orderstatuses').then(result => result.data.orderBy('Description')));
    }
    service.$inject = ["$http"];
    
})()